import React from "react";
import { Button, Form, ListGroup, Modal, Spinner } from "react-bootstrap";

const ClienteSelectorModal = ({
  show,
  onHide,
  search,
  onSearchChange,
  loading,
  results,
  selectedKey,
  onSelect,
  onConfirm,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Cambiar cliente</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Control
            type="text"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Buscar por nombre, razón social, CUIT, terminal, comercio o legajo"
          />
        </Form.Group>

        <div className="crm-postventa-modal-results">
          {loading ? (
            <div className="crm-postventa-loading-inline">
              <Spinner animation="border" size="sm" className="me-2" />
              Buscando clientes...
            </div>
          ) : (
            <ListGroup variant="flush">
              {results.length === 0 ? (
                <div className="crm-postventa-empty-modal">
                  No encontramos clientes con esa búsqueda.
                </div>
              ) : (
                results.map((cliente) => (
                  <ListGroup.Item
                    key={cliente.groupKey}
                    action
                    active={selectedKey === cliente.groupKey}
                    onClick={() => onSelect(cliente)}
                    className="crm-postventa-modal-item"
                  >
                    <div className="form-check m-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        checked={selectedKey === cliente.groupKey}
                        onChange={() => onSelect(cliente)}
                      />
                      <label className="form-check-label w-100">
                        <span className="crm-postventa-modal-title">
                          {cliente.nombreDeFantasia || cliente.razonSocial || "Sin nombre"}
                        </span>
                        <span className="crm-postventa-modal-meta">
                          {cliente.resumen}
                        </span>
                      </label>
                    </div>
                  </ListGroup.Item>
                ))
              )}
            </ListGroup>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="success" onClick={onConfirm} disabled={!selectedKey}>
          Seleccionar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ClienteSelectorModal;
